import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { RequisitosService } from '../../_services/requisitos.service';
import { Requisito } from '../../_models/requisito';

@Component( {
  selector: 'app-homologacion-lista-listado',
  templateUrl: 'requisitos-listado.component.html'
} )

export class RequisitosListadoComponent implements OnInit {

  /**
   * variable para mantener la busqueda
   */
  busqueda: string;
  /**
   * Indicador de cargado del listado de requisitos.
   * @type {boolean}
   */
  cargando = true;
  columns: any[];
  @ViewChild('dt', { static: true }) table: Table;
  menu: Funcionalidad = new Funcionalidad();
  listadoRequisitos: Requisito[] = [];
  cargandoRequisitos = true;

  constructor(
    private requisitosServicio: RequisitosService,
    private router: Router,
    private autServicio: AutenticacionService,
    private navServicio: NavService ) {
  }

  /**
   * carga lista de requisitos
   */
  ngOnInit() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/requisitos' );
    if ( mn ) {
      this.menu = mn;
    }
    this.columns = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'REQUISITOS.LBL_NOMBRE' ), sort: true },
      { field: 'montoMaximo', header: this.navServicio.buscarMensaje( 'REQUISITOS.LBL_MONTOMAXIMO' ) + '(SMLV)', sort: true },
      { field: 'garantia', header: this.navServicio.buscarMensaje( 'REQUISITOS.LBL_GARANTIASOLICITADA' ), sort: true },
      { field: 'indicadorRequiereFondoGarantiaIdonea', header: this.navServicio.buscarMensaje( 'REQUISITOS.LBL_REQUIEREGARANTIA' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'requisitos.component' );
    this.requisitosServicio.listado().subscribe( plaga => {
      this.listadoRequisitos = plaga;
      this.cargandoRequisitos = false;
      this.table.filterGlobal( this.busqueda, 'contains' );
    } );

  }

  /**
   * navega a pantalla para agregar requisitos
   */
  agregar() {
    this.router.navigate( [ 'apl/requisitos/agregar' ] );
  }

  /**
   * navega a pantalla para actualizar requisitos pasa como parametro idRequisito
   * @param dato
   */
  editar( dato: Requisito ) {
    this.router.navigate( [ 'apl/requisitos/actualizar/', dato.idRequisitoGarantia ] );
  }

  /**
   * navega a pantalla para visualizar requisitos pasa como parametro idRequisito
   * @param dato
   */
  detalle( dato: Requisito ) {
    this.router.navigate( [ 'apl/requisitos/detalle/', dato.idRequisitoGarantia ] );
  }

  /**
   * asignar valor a variable para mantener busqueda
   */
  setSearch() {
    this.navServicio.setSearch( 'requisitos.component', this.busqueda );
  }

}
